
// const url = "http://34.93.209.224:8000"
// const url = "http://3.140.210.76:8000";

// const url = "http://13.127.127.40:80"; 
// 29april

// const url = 'http://34.93.209.224:8000'
const url = 'http://34.93.209.224:8000'
//  2 june 2022

// ngrok link

// const url = 'https://90df-223-227-87-143.in.ngrok.io'


export { url };
